import type { PageFilters } from "./types";

const areValuesEqual = (a: string, b: string): boolean => {
  if (a === b) {
    return true;
  }

  if (!a.includes(",") && !b.includes(",")) {
    return false;
  }

  const setA = new Set(a.split(","));
  const setB = new Set(b.split(","));

  if (setA.size !== setB.size) {
    return false;
  }

  for (const val of setA) {
    if (!setB.has(val)) {
      return false;
    }
  }

  return true;
};

export const areFiltersEqual = (a: PageFilters, b: PageFilters): boolean => {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  return keysA.every((key) => {
    if (!(key in b)) {
      return false;
    }
    const valA = a[key] ?? "";
    const valB = b[key] ?? "";
    return areValuesEqual(valA, valB);
  });
};
